<template>
  <div class="upload" :class="fileInfo? 'disabled' : ''">
    <a href="javascript:;" class="a-upload" :class="fileInfo? 'disabled' : ''">
      <translate>Choose File</translate>
      <input type="file" :disabled="fileInfo" id="file" @change="onChange" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
    </a>
  </div>
</template>

<script>

  export default{
    props: {
      progress: {
        require: true
      },
      done: {
        type: Function,
        default: () => {}
      },
      fileInfo: {
        require: true
      }
    },
    methods: {
      onClick () {
        document.getElementById('file').click()
      },
      onChange (e) {
        let files = e.target.files
        let allFiles = []
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          let reader = new FileReader()
          // Convert the file to base64 text
          reader.readAsDataURL(file)
          reader.onprogress = (e) => {
            if (e.lengthComputable) {
              let percentComplete = e.loaded / e.total * 100
              this.progress(percentComplete)
            } else {
              console.log('total size is unknown')
            }
          }
          reader.onload = () => {
            // Make a fileInfo Object
            let fileInfo = {
              name: file.name,
              type: file.type,
              size: Math.round(file.size),
              base64: reader.result,
              file: file
            }
            allFiles.push(fileInfo)
            // If all files have been proceed
            if (allFiles.length === files.length) {
              if (this.multiple) this.done(allFiles)
              else this.done(allFiles[0])
            }
            e.target.value = ''
          }
        }
      }
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../../assets/css/variable";

  .upload {
    display: inline-block;
    padding-bottom: 5px;
    background-color: $mainColor;
    border-radius: 2px;
    &:hover {
      cursor: pointer;
    }
    &.disabled {
      background-color: #eef1f6;
      cursor:not-allowed;
    }
  }

  .a-upload {
    position: relative;
    padding: 4px 12px;
    color: #fff;
    text-decoration: none;
    text-indent: 0;
    line-height: 20px;
    &:hover {
      color: #fff;
      cursor: pointer;
    }
    &.disabled {
      color: #bfcbd9;
    }
  }

  .a-upload input {
    display: none;
    position: absolute;
    font-size: 23px;
    width: 80px;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    &:hover {
      cursor: pointer
    }
  }
  input[disabled]:hover {
    cursor:not-allowed;
  }

</style>




// WEBPACK FOOTER //
// vue-upload-file.vue?7720a19f